var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('contained-page-layout',[_c('document-title',{attrs:{"value":"Orders"}}),_c('view-all-orders')],1)}
var staticRenderFns = []

export { render, staticRenderFns }